import photosData from "../data/photos.json";

export function getPhotos(category) {
  if (!category || category === "all") return photosData;
  return photosData.filter((p) => p.category === category);
}

export function getAllPhotos() {
  return photosData;
}

export const CATEGORY_LABELS = {
  portraits: "Retratos",
  street: "Calle",
  architecture: "Edificios",
};
